module.exports = __webpack_public_path__ + "media/images/emblems/Suchy-coat_of_arms-3d3e6a055be9705c6cce030191eaf4d3.svg";